import React from "react";
import _ from "lodash";
import { CFItem, ReportValues, SummaryReport } from "../../../types";

const defaultReportValue: ReportValues = {
  previous: "-",
  "%change": "-",
  current: "-",
};

const defaultValues: SummaryReport = {
  sliceId: "-",
  reportValues: defaultReportValue,
};

export function summaryValues(
  sliceIdPath: string,
  projectedPath: string,
  currentPath: string,
  summary: CFItem
): SummaryReport {
  if (Object.keys(summary).length === 0) {
    return defaultValues;
  } else {
    return summary.projected
      ? {
          sliceId: _.get(summary, sliceIdPath, ""),
          reportValues: _.get(summary, projectedPath, defaultReportValue),
        }
      : {
          sliceId: "SOD",
          reportValues: _.get(summary, currentPath, defaultReportValue),
        };
  }
}

export default summaryValues;
